import { Label } from "@/components/ui/label";
import { UnitSelector } from "./UnitSelector";

interface UnitFieldProps {
  unit: string;
  customUnit: string;
  onUnitChange: (value: string) => void;
  onCustomUnitChange: (value: string) => void;
  isPoultry?: boolean;
}

export const UnitField = ({
  unit,
  customUnit,
  onUnitChange,
  onCustomUnitChange,
  isPoultry = false,
}: UnitFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="unit">Unité</Label>
      <UnitSelector
        unit={unit}
        customUnit={customUnit}
        onUnitChange={onUnitChange}
        onCustomUnitChange={onCustomUnitChange}
        isPoultry={isPoultry}
      />
    </div>
  );
};